module.exports = __webpack_public_path__ + "static/media/manualSk.f71bfaef.pdf";